<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Referral claim report</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{name: 'Home'}">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Referral claim report</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="container-fluid">
        <div class="card" id="RefClaim">
          <div class="overlay" v-if="is_loading">
            <i class="fas fa-2x fa-sync-alt fa-spin"></i>
          </div>
          <form @submit.prevent="handleSubmission()" method="POST" novalidate>
            <div class="card-header">
              <h3 class="card-title" v-if="!is_edit">Create</h3>
              <h3 class="card-title" v-if="is_edit">Edit</h3>
              <div class="card-tools">
                <router-link class="btn btn-info" :to="{name: 'RefClaimList'}"><i class="fas fa-list"></i> List
                </router-link>
              </div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-8">
                  <div class="form-group required">
                    <label class="control-label">Full name</label>
                    <input type="text" id="full_name" name="full_name"
                           v-bind:class="{'has-error' : errors.has('full_name')}"
                           v-validate="'required'"
                           v-model="value.full_name" class="form-control full_name"
                           placeholder="Full Name">
                    <div class="help text-danger" v-show="errors.has('full_name')">
                      {{ errors.first("full_name") }}
                    </div>
                  </div>
<!--                  <div class="form-group">
                    <label class="control-label">NID No</label>
                    <input type="text" id="nid_number" name="nid_number"
                           v-model="value.nid_number" class="form-control nid_number"
                           placeholder="NID No">
                    <div class="help text-danger" v-show="errors.has('nid_number')">
                      {{ errors.first("nid_number") }}
                    </div>
                  </div>
                  <div class="form-group required">
                    <label class="control-label">Claimed points</label>
                    <input type="text" id="points" name="points"
                           v-model="value.points" class="form-control points"
                           placeholder="points">
                    <div class="help text-danger" v-show="errors.has('points')">
                      {{ errors.first("points") }}
                    </div>
                  </div>-->
                  <div class="form-group required">
                    <label class="control-label">Amount (TK)</label>
                    <input type="text" id="earning" name="earning"
                           v-model="value.earning" class="form-control earning"
                           placeholder="earning">
                    <div class="help text-danger" v-show="errors.has('earning')">
                      {{ errors.first("earning") }}
                    </div>
                  </div>
                  <div class="form-group required">
                    <label class="control-label">Email</label>
                    <input type="text" id="email" name="email"
                           v-model="value.email" class="form-control email"
                           placeholder="Email">
                  </div>
                  <div class="form-group required">
                    <label class="control-label">bKash number</label>
                    <input type="text" id="mobile_bank" name="mobile_bank"
                           v-model="value.mobile_bank" class="form-control mobile_bank"
                           placeholder="bKash">
                    <div class="help text-danger" v-show="errors.has('mobile_bank')">
                      {{ errors.first("mobile_bank") }}
                    </div>
                  </div>
                  <div class="form-group required">
                    <label class="control-label">Status</label>
                    <el-select v-model="value.status" id="status" style="width: 100%;" filterable placeholder="Status">
                      <el-option
                        v-for="item in [{value: 'pending',label: 'Pending'},
                          {value: 'paid',label: 'Paid'},{value: 'rejected',label: 'Rejected'}]"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      />
                    </el-select>
                    <div class="help text-danger" v-show="errors.has('status')">
                      {{ errors.first("status") }}
                    </div>
                  </div>

                  <div class="form-group">
                    <label for="notes" class="control-label">Notes</label>
                    <textarea id="notes" rows="4" cols="3"
                              name="notes"
                              v-model="value.notes"
                              class="form-control"
                              :class="{ 'has-error': errors.has('notes') }"/>
                    <div class="help text-danger" v-show="errors.has('notes')">
                      {{ errors.first("notes") }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer">
              <button type="submit" v-if="!is_edit" class="btn btn-primary">Submit</button>
              <button type="submit" v-if="is_edit" class="btn btn-primary">Update</button>
            </div>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>

<script>

//import MasterLayout from "@/components/layouts/MasterLayoutComponent";
import {DepartmentsAPI, CommonAPI} from '@/services/api'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import axios from 'axios'

export default {
  name: 'RefClaimForm',
  metaInfo: {
    title: 'Ref Claim | Dotlines'
  },
  components: {
    DatePicker
  },
  data: () => ({
    isSelectorLoading: false,
    is_loading: false,
    is_edit: false,
    params: {},

    value: {},
    pre: {}
  }),
  methods: {
    handleSubmission() {
      let _this = this;
      this.$validator.validateAll().then((result) => {
        if (result) {
          _this.is_loading = true
          let api_url = '/ref_claims'
          let method = 'POST'
          if (_this.is_edit) {
            api_url = '/ref_claims/' + _this.$route.params.id
            method = 'PUT'
          }

          axios({
            method: method,
            url: api_url,
            data: _this.value,
            headers: {'Content-Type': 'application/json'},
          }).then(function (response) {
            _this.$toaster.success(response.data.message)
            _this.$router.push({'name': 'RefClaimList'})
          }).catch((errors) => {
            if (errors.response.status === 500) {
              _this.$toaster.error(errors.response.data.message)
            }
            _this.$setErrorsFromResponse(errors.response.data)
          }).finally(() => {
            _this.is_loading = false
          });
        }
      });
    },
    getDetail: function (id) {
      return new Promise((resolve, reject) => {
        let api_url = '/ref_claims/' + id
        axios.get(api_url)
          .then(response => {
            resolve(response)
          })
          .catch((error) => {
            //console.log('error ' + error)
            reject(error)
          });
      });
    },
    async initialize() {
      this.is_loading = true
      this.params = this.$route.params

      if (!_.isEmpty(this.params) && this.params.id !== undefined) {
        this.is_edit = true
      }
      if (this.is_edit) {
        await this.getDetail(this.params.id).then(response => {
          this.value = response.data
        }).catch((error) => {
          console.log(error.response)
        })


      }

      this.is_loading = false
    }
  },
  mounted() {
    this.initialize()
  },
  /* created() {
    this.$emit("update:layout", MasterLayout);
  }, */
}
</script>

